import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { IconContext } from 'react-icons'
import vhCheck from 'vh-check'
import 'animate.css/animate.min.css'
import { ThemeProvider } from 'styled-components'
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles'
import { Toaster } from 'react-hot-toast'
import { doesRouteMatch } from './helpers'
import { Home, Auth, Order, DelieveryRequest, Support, Location, User } from './View'
import TrackOrder from './View/TrackOrder'
import EmbedTrackOrder from './View/EmbedTrackOrder'
import { AdminDashboard } from './View/Admin'
import { CompanyDashboard } from './View/Company'
import { TopNav, Footer } from './Layout'
import { initializeAuth } from './store/actions'
import { setupTokenRefresh } from './utils/tokenManager'
import theme from './base/theme'
import GlobalStyle from './base/globalStyles'
import Terms from './View/Terms/Terms'
import Policy from './View/Policy'

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [pathname])

  return null
}

const App = () => {
  const dispatch = useDispatch()
  const { UserData } = useSelector((s) => s)
  const { authenticated } = useSelector((s) => s.UserData)

  // Initialize auth state from cookies on app load
  useEffect(() => {
    dispatch(initializeAuth())
    
    // Setup automatic token refresh
    setupTokenRefresh()
  }, [dispatch])

  vhCheck()
  const { pathname } = useLocation()
  const hideNavAndFooter = doesRouteMatch(
    ['auth', 'delievery-request', 'dashboard', 'company', 'embed'],
    pathname,
  )

  // Create Material-UI theme for MaterialTable
  const muiTheme = createTheme({
    palette: {
      primary: {
        main: '#1976d2',
      },
      secondary: {
        main: '#dc004e',
      },
      background: {
        default: '#fafafa',
        paper: '#fff',
      },
    },
  })

  return (
    <MuiThemeProvider theme={muiTheme}>
      <ThemeProvider theme={theme()}>
      <GlobalStyle />
      <Toaster />
      <IconContext.Provider value={{ className: 'icon' }}>
        {!hideNavAndFooter && <TopNav />}
        <div
          className="app--container"
          style={{
            paddingTop: !hideNavAndFooter ? theme().navHeight : 0,
          }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<Home />} />
            <Route path="/auth/:authMethod" element={authenticated ? <Navigate to="/dashboard" replace /> : <Auth />} />
            <Route path="/orders" element={<Order />} />
            <Route path="/track-order" element={<TrackOrder />} />
            <Route path="/track-order/:trackingNumber" element={<TrackOrder />} />
            <Route path="/embed/track/:trackingNumber" element={<EmbedTrackOrder />} />
             <Route path="/locations" element={<Location />} />
           <Route path="/support" element={<Support />} />
            <Route path="/delievery-request/:stage" element={<DelieveryRequest />} />
             <Route path="/terms" element={<Terms />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/dashboard/*" element={
              authenticated ? (
                (UserData.userData?.role === 'ADMIN' || UserData.userData?.role === 'SUPER_ADMIN') ? <AdminDashboard /> : <Navigate to="/company/dashboard" replace />
              ) : (
                <Navigate to="/auth/sign-in" replace />
              )
            } />
            <Route path="/company/dashboard/*" element={
               <CompanyDashboard /> } />
          </Routes>
          <ScrollToTop />
          {!hideNavAndFooter && <Footer />}
        </div>
        <div>
        </div>
      </IconContext.Provider>
    </ThemeProvider>
    </MuiThemeProvider>
  )
}

export default App